export class MyClientsReSignRequestModel {
    id_pais: string = '1';
    tipo_documento: string;
    documento: number;
    documento_comprador: number;
    tipo_documento_comprador: string = "C";
}
